import { api2 } from '@/public/utils/basePath';
import { cryptoInstance } from '@/public/fetch/index';
const baseURL = api2;
/**
 * @params
 * userId
 * @query
 * pageSize
 * pageNo
 * labelId 亚专业Id
 */
export const getArticleList = ({ params, query }) => {
    // 获取亚专业列表
    return cryptoInstance.get(`/v5/article/list/${params.userId}`, {
        baseURL: api2,
        params: query
    });
};
/**
 * @params
 * userId
 * @query
 * pageNo
 * pageSize
 * labelId
 */
export const getExerciseList = ({ params, query }) => {
    return cryptoInstance.get(`/v5/exercise/list/${params.userId}`, {
        baseURL: api2,
        params: query
    });
};
/**
 * @params
 * userId
 * @query
 * pageNo
 * pageSize
 * labelId
 */
export const getDocumentList = ({ params, query }) => {
    return cryptoInstance.get(`/v5/document/list/${params.userId}`, {
        baseURL: api2,
        params: query
    });
};
/**
 * 获取支付成功二维码
 * id： meetingId vipId 等
 * module： exercise meeting
 */
export const getWechatQe = (params) => {
    return cryptoInstance.get(`v5/wechatCode/pay/${params.module}/${params.id}`, {
        baseURL: api2
    });
};
// 获取直播列表
export const getLiveList = (userId, params) => {
    return cryptoInstance.get(`/lesson/v8/index_live/${userId}`, {
        baseURL,
        params
    });
};
